import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { CardColor } from '@usf/payment-types';
@Component({
  selector: 'app-row-cards-touch',
  templateUrl: './row-cards-touch.component.html',
  styleUrls: ['./row-cards-touch.component.scss'],
})
export class RowCardsTouchComponent implements OnChanges {
  @Input() customerName: string;
  @Input() customerNumber: number;
  @Input() status: string;
  @Input() subtitle: string;
  @Input() color: CardColor = 'gray';
  @Input() showColorCircle = true;
  @Input() additionalInfo: string;
  @Input() hasLink = false;
  @Input() linkText: string;
  @Input() icon: string;
  @Input() selectable = false;
  @Input() selected = false;
  @Input() edgeAction: string;
  @Input() columnsData: { text: string; value: string }[][];
  @Input() showVoidColumns = false;
  @Output() checkboxChange = new EventEmitter<Event>();
  @Output() iconClick = new EventEmitter<void>();
  @Output() cardClick = new EventEmitter<void>();
  @Output() linkClick = new EventEmitter<void>();
  @Output() edgeActionClick = new EventEmitter<void>();

  columnSize: string;
  columnCount: number;

  ngOnChanges() {
    this.columnCount = this.showVoidColumns
      ? this.columnsData.length
      : this.columnsData.reduce(
          (prev, curr) => (curr.length > 0 ? prev + 1 : prev),
          0,
        );
    this.columnSize = this.getColumnSize();
  }

  getColumnSize() {
    return (11 / this.columnCount).toString();
  }
}
